<template>
  <div class="w-100 h-100">
    <dv-border-box-7>
      <div style="text-align: center;padding:0px 20px;height:7%">
        <div :style="{ 'color': 'white', 'font-size': '0.55rem', 'font-weight': 'bold' }">
          {{
            dataBean['title'] }}
        </div>
      </div>
      <div class="h-47">
        <div class="w-100 h-100 p-tb" :id="dataBean['id'] + 'monthDiscoveryRateEchart'"></div>
      </div>
      <div class="h-47">
        <div class="w-100 h-100 p-tb" :id="dataBean['id'] + 'deptDiscoveryRateEchart'"></div>
      </div>
    </dv-border-box-7>
  </div>
</template>

<script>
export default {
  name: "fr-issue-table",
  props: {
    bean: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      dataBean: this.bean,
      monthCharts: null,
      deptCharts: null,
    };
  },
  watch: {
    bean: {
      handler: function (val, oldVal) {
        this.dataBean = val;
        console.log(this.dataBean);
        this.lineDeptEchart();
        this.lineMonthEchart();
      },
      deep: true,
    },
  },
  mounted() {
    // this.lineEchart();
  },
  methods: {
    fontSize(res) {
      let docEl = document.documentElement,
        clientWidth =
          window.innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth;
      if (!clientWidth) return;
      let fontSize = 100 * (clientWidth / 1920);
      return res * fontSize;
    },
    lineDeptEchart() {

      var id = this.dataBean['id'];

      var lineEchart = this.$echarts.init(
        document.getElementById(id + "deptDiscoveryRateEchart")
      );

      var data = this.dataBean['deptData'];

      const xAxis = [];
      const lineData = [];
      const barData = [];
      const closedCount = [];
      const unCount = []; //限期内围观
      const expiredCount = []; //逾期未关闭
      let periodText = "";
      data.forEach((item) => {
        switch (item.period) {
          case "year":
            periodText = "年";
            break;
          case "month":
            periodText = "月";
            break;
          case "day":
            periodText = "日";
        }
        this.tableTitle = periodText;
        xAxis.push(item.periodValue);
        lineData.push(item.issueCount);
        closedCount.push(item.closedCount);
        unCount.push(item.issueCount - item.closedCount - item.uclosedCount);
        expiredCount.push(item.uclosedCount);
        if (item.issueCount == 0) {
          barData.push(0);
        } else {
          barData.push(
            parseInt((item.closedCount / item.issueCount) * 100 + "", 0)
          );
        }
      });

      var option = {
        grid: {
          left: "10",
          right: "0",
          bottom: "0",
          top: 75,
          y2: 40,
          containLabel: true,
        },
        title: {
          text: "部门关闭率",
          left: "10",
          textStyle: {
            color: "#ffffff",
            fontSize: "24",
          },
        },
        tooltip: {
          trigger: "axis",
          extraCssText: 'z-index: 99 !important;',
        },
        legend: {
          data: ["期限内未关闭", "逾期未关闭", "已关闭", "关闭率"],
          right: 5,
          textStyle: {
            color: "#ffffff", //字体颜色
            fontSize: 16,
          },
          itemGap: 2,
        },
        xAxis: [
          {
            type: "category",
            data: xAxis,
            axisPointer: {
              type: "shadow",
            },
            axisLabel: {
              interval: 0,
              //  rotate: 20,
              fontSize: 13,
            },
            axisLine: {
              lineStyle: {
                color: "#fff",
              },
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "问题数",
            nameTextStyle: {
              fontSize: 14,
            },
            min: 0,
            nameTextStyle: {
              fontSize: 13,
            },
            axisLabel: {
              formatter: "{value}",
            },
            axisLine: {
              lineStyle: {
                color: "#fff",
              },
            },
            splitLine: {
              show: false,
            },
          },
          {
            type: "value",
            name: "关闭率",
            min: 0,
            nameTextStyle: {
              fontSize: 13,
            },
            axisLabel: {
              formatter: "{value} %",
            },
            axisLine: {
              lineStyle: {
                color: "#fff",
              },
            },
            splitLine: {
              show: false,
            },
          },
        ],
        series: [
          {
            color: ["#00CD66"],
            name: "已关闭",
            type: "bar",
            stack: "total",
            barMaxWidth: "100%",
            data: closedCount,
            itemStyle: {
              normal: {
                label: {
                  show: true, //开启显示
                  textStyle: {
                    //数值样式
                    color: "white",
                    fontSize: 14,
                  },
                  formatter: (params) => {
                    return (params.value > 0 ? params.value : '');
                  },
                },
              },
            },
          },
          {
            color: ["#FFcc99"],
            name: "期限内未关闭",
            type: "bar",
            stack: "total",
            barMaxWidth: "50%",
            data: unCount,
            itemStyle: {
              normal: {
                label: {
                  show: true, //开启显示
                  textStyle: {
                    //数值样式
                    color: "#fff",
                    fontSize: 14,
                  },
                  formatter: (params) => {
                    return (params.value > 0 ? params.value : '');
                  },
                },
              },
            },
          },
          {
            color: ["red"],
            name: "逾期未关闭",
            type: "bar",
            stack: "total",
            barMaxWidth: "50%",
            data: expiredCount,
            itemStyle: {
              normal: {
                label: {
                  show: true, //开启显示
                  textStyle: {
                    //数值样式
                    color: "white",
                    fontSize: 14,
                  },
                  formatter: (params) => {
                    return (params.value > 0 ? params.value : '');
                  },
                },
              },
            },
          },
          {
            color: ["#00CD66"],
            name: "关闭率",
            type: "line",
            yAxisIndex: 1,
            data: barData,
            itemStyle: {
              normal: {
                //改变折线点的颜色
                lineStyle: {
                  color: "#00CD66", //改变折线颜色
                  fontSize: 14,
                },
              },
            },
          },
        ],
      };

      lineEchart.setOption(option);
      //图标随窗口大小缩放
      window.addEventListener("resize", function () {
        lineEchart.resize();
      });

    },
    lineMonthEchart() {

      var id = this.dataBean['id'];

      var lineEchart = this.$echarts.init(
        document.getElementById(id + "monthDiscoveryRateEchart")
      );

      var data = this.dataBean['issueList'];

      const xAxis = [];
      const lineData = [];
      const barData = [];
      const closedCount = [];
      const unCount = []; //限期内围观
      const expiredCount = []; //逾期未关闭
      let periodText = "";
      data.forEach((item) => {
        switch (item.period) {
          case "year":
            periodText = "年";
            break;
          case "month":
            periodText = "月";
            break;
          case "day":
            periodText = "日";
        }
        this.tableTitle = periodText;
        xAxis.push(item.periodValue);
        lineData.push(item.issueCount);
        closedCount.push(item.closedCount);
        unCount.push(item.issueCount - item.closedCount - item.uclosedCount);
        expiredCount.push(item.uclosedCount);
        if (item.issueCount == 0) {
          barData.push(0);
        } else {
          barData.push(
            parseInt((item.closedCount / item.issueCount) * 100 + "", 0)
          );
        }
      });

      var option = {
        grid: {
          left: "10",
          right: "0",
          bottom: "0",
          top: 75,
          y2: 40,
          containLabel: true,
        },
        title: {
          text: "月度关闭率",
          left: "10",
          textStyle: {
            color: "#ffffff",
            fontSize: "24",
          },
        },
        tooltip: {
          trigger: "axis",
          extraCssText: 'z-index: 99 !important;',
        },
        legend: {
          data: ["期限内未关闭", "逾期未关闭", "已关闭", "关闭率"],
          right: 5,
          textStyle: {
            color: "#ffffff", //字体颜色
            fontSize: 16,
          },
          itemGap: 2,
        },
        xAxis: [
          {
            type: "category",
            data: xAxis,
            axisPointer: {
              type: "shadow",
            },
            axisLabel: {
              interval: 0,
              rotate: 0,
              fontSize: 13,
            },
            axisLine: {
              lineStyle: {
                color: "#fff",
              },
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "问题数",
            nameTextStyle: {
              fontSize: 18,
            },
            min: 0,
            nameTextStyle: {
              fontSize: 13,
            },
            axisLabel: {
              formatter: "{value}",
            },
            axisLine: {
              lineStyle: {
                color: "#fff",
              },
            },
            splitLine: {
              show: false,
            },
          },
          {
            type: "value",
            name: "关闭率",
            min: 0,
            nameTextStyle: {
              fontSize: 14,
            },
            axisLabel: {
              formatter: "{value} %",
            },
            axisLine: {
              lineStyle: {
                color: "#fff",
              },
            },
            splitLine: {
              show: false,
            },
          },
        ],
        series: [
          {
            color: ["#00CD66"],
            name: "已关闭",
            type: "bar",
            stack: "total",
            barMaxWidth: "80%",
            data: closedCount,
            itemStyle: {
              normal: {
                label: {
                  show: true, //开启显示
                  textStyle: {
                    //数值样式
                    color: "white",
                    fontSize: 14,
                  },
                  formatter: (params) => {
                    return (params.value > 0 ? params.value : '');
                  },
                }
              },
            },
          },
          {
            color: ["#FFcc99"],
            name: "期限内未关闭",
            type: "bar",
            stack: "total",
            barMaxWidth: "80%",
            data: unCount,
            itemStyle: {
              normal: {
                label: {
                  show: true, //开启显示
                  textStyle: {
                    //数值样式
                    color: "#fff",
                    fontSize: 14,
                  },
                  formatter: (params) => {
                    return (params.value > 0 ? params.value : '');
                  },
                },
              },
            },
          },
          {
            color: ["red"],
            name: "逾期未关闭",
            type: "bar",
            stack: "total",
            barMaxWidth: "80%",
            data: expiredCount,
            itemStyle: {
              normal: {
                label: {
                  show: true, //开启显示
                  textStyle: {
                    //数值样式
                    color: "white",
                    fontSize: 14,
                  },
                  formatter: (params) => {
                    return (params.value > 0 ? params.value : '');
                  },
                },
              },
            },
          },
          {
            color: ["#00CD66"],
            name: "关闭率",
            type: "line",
            yAxisIndex: 1,
            data: barData,
            itemStyle: {
              normal: {
                //改变折线点的颜色
                lineStyle: {
                  color: "#00CD66", //改变折线颜色
                  fontSize: 14,
                },
              },
            },
          },
        ],
      };

      lineEchart.setOption(option);
      //图标随窗口大小缩放
      window.addEventListener("resize", function () {
        lineEchart.resize();
      });

    }
  },
  destroyed() {
    if (this.deptCharts) {
      clearInterval(this.deptCharts);
    }
    if (this.monthCharts) {
      clearInterval(this.monthCharts);
    }
  },
};
</script>
<style scoped></style>


// WEBPACK FOOTER //
// src/pages/fr/report/groups/component/fr-issue-table.vue